import { startOfDay, startOfMonth, startOfQuarter, startOfYear } from 'date-fns';
import { SurveyDefaultDatePeriod } from '../../Surveys/surveyInterface';

const periodStartDate = (defaultDatePeriod?: SurveyDefaultDatePeriod): Date | undefined => {
    const today = new Date();

    switch (defaultDatePeriod) {
        case SurveyDefaultDatePeriod.ALL:
            return undefined;
        case SurveyDefaultDatePeriod.CURRENT_DAY:
            return startOfDay(today);
        case SurveyDefaultDatePeriod.CURRENT_TRIM:
            return startOfQuarter(today);
        case SurveyDefaultDatePeriod.CURRENT_YEAR:
            return startOfYear(today);
        case SurveyDefaultDatePeriod.CURRENT_MONTH:
        default:
            return startOfMonth(today);
    }
};

// Calendar selection applied when a dashboard or the hot alerts are opened on a
// survey filtered by answer date. ALL leaves the calendar empty: the whole base.
const getDefaultDateRange = (defaultDatePeriod?: SurveyDefaultDatePeriod) => {
    const startDate = periodStartDate(defaultDatePeriod);

    return {
        selection: {
            startDate,
            endDate: startDate ? new Date() : undefined,
            key: 'selection',
        },
    };
};

export default getDefaultDateRange;
